import React from 'react';
import { motion } from 'framer-motion';
import { useRotatingText } from './hooks/useRotatingText';
import { ROTATION_TEXTS } from './constants/text';
import { textGradient } from './styles/gradients';

export default function HeroHeadline() {
  const { text, isAnimating } = useRotatingText({
    texts: ROTATION_TEXTS
  });

  return (
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 lg:text-left"
    >
      <div className="mb-4">
        Accelerate Your Career with
      </div>
      <div 
        className={`transition-all duration-500 min-h-[1.2em] ${
          isAnimating ? 'opacity-0 translate-y-8' : 'opacity-100 translate-y-0'
        }`}
      >
        <span className={textGradient}>
          {text}
        </span>
      </div>
    </motion.h1>
  );
}